import {StateProvider, StateService} from "@uirouter/angularjs";
import {AccountStore} from "../../account/store/AccountStore";

export function routerConfig($stateProvider: StateProvider) {
    $stateProvider.state("home", {
        url: "/",
        onEnter: stateRedirect
    });
}

/** @ngInject */
export const stateRedirect = (accountStore: AccountStore, $state: StateService) => {
    return accountStore.current.first().toPromise().then((current) => {
        return $state.target("portfolio", {portfolioId: current?.id ?? -1});
    });
};
